import React from 'react';
import i18next from 'i18next';

import ShoppingCell from 'components/molecules/MbTable/ShoppingCell';

export let popTabList = [];

/**
 * popGroup : adver
 */
popTabList['adver'] = {
  '/report/adver/statistics': {
    key: '/report/adver/statistics',
    value: {
      menuNm: '광고주별통계',
    },
  },
  '/report/adver/detail': {
    key: '/report/adver/detail',
    value: {
      menuNm: '광고주별상세통계',
    },
  },
};
/**
 * popGroup : adverStatistics
 */
popTabList['adverStatistics'] = {
  '/report/daily/par': {
    key: '/report/daily/par',
    value: {
      menuNm: '일자별 통계',
    },
  },
  '/report/timeamt': {
    key: '/report/timeamt',
    value: {
      menuNm: '시간대별 통계',
    },
  },
  '/report/freq/graphStt': {
    key: '/report/freq/graphStt',
    value: {
      menuNm: '프리퀀시통계[전략별]',
    },
  },
  '/report/freq/graphCross': {
    key: '/report/freq/graphCross',
    value: {
      menuNm: '프리퀀시통계[교차]',
    },
  },
  '/report/freq/ttimegraph': {
    key: '/report/freq/ttimegraph',
    value: {
      menuNm: 'T-Time별통계[변수별]',
    },
  },
  '/report/freq/ttimegraphStt': {
    key: '/report/freq/ttimegraphStt',
    value: {
      menuNm: 'T-Time별통계[전략별]',
    },
  },
};
/**
 * popGroup : media
 */
popTabList['media'] = {
  '/report/daily/par': {
    key: '/report/daily/par',
    value: {
      menuNm: '일자별 통계',
    },
  },
  '/report/daily/targeting': {
    key: '/report/daily/targeting',
    value: {
      menuNm: '구좌별 타게팅분포',
    },
  },
  '/report/timeamt': {
    key: '/report/timeamt',
    value: {
      menuNm: '시간대별 통계',
    },
  },
  '/report/adver/compare': {
    key: '/report/adver/compare',
    value: {
      menuNm: '광고주별 비교',
    },
  },
  '/report/adver/sectionCompare': {
    key: '/report/adver/sectionCompare',
    value: {
      menuNm: '광고주별 구간비교',
    },
  },
  '/report/daily/longTime': {
    key: '/report/daily/longTime',
    value: {
      menuNm: '6개월 분석표',
    },
  },
};

/**
 * popGroup : media_rtb (media와 같으나 RTB일자별통계가 추가됨)
 */
popTabList['media_rtb'] = {
  '/report/daily/par': {
    key: '/report/daily/par',
    value: {
      menuNm: '일자별 통계',
    },
  },
  '/report/daily/targeting': {
    key: '/report/daily/targeting',
    value: {
      menuNm: '구좌별 타게팅분포',
    },
  },
  '/report/timeamt': {
    key: '/report/timeamt',
    value: {
      menuNm: '시간대별 통계',
    },
  },
  '/report/adver/compare': {
    key: '/report/adver/compare',
    value: {
      menuNm: '광고주별 비교',
    },
  },
  '/report/adver/sectionCompare': {
    key: '/report/adver/sectionCompare',
    value: {
      menuNm: '광고주별 구간비교',
    },
  },
  '/report/daily/longTime': {
    key: '/report/daily/longTime',
    value: {
      menuNm: '6개월 분석표',
    },
  },
  '/report/openrtb/day': {
    key: '/report/openrtb/day',
    value: {
      menuNm: 'RTB 일자별통계',
    },
  },
};

/**
 * popGroup : local  (지역타겟팅통계에서 사용)
 */
popTabList['local'] = {
  '/report/local/day': {
    key: '/report/local/day',
    value: {
      menuNm: '일자별 통계',
    },
  },
  '/report/local/local': {
    key: '/report/local/local',
    value: {
      menuNm: '지역별 통계',
    },
  },
};
/**
 * popGroup : OpenRTB MEDIA POPUP
 */
popTabList['openRtbMediaPopup'] = {
  '/report/openrtb/day': {
    key: '/report/openrtb/day',
    value: { menuNm: '일자별 통계' },
  },
  '/report/openrtb/target': {
    key: '/report/openrtb/target',
    value: { menuNm: '타게팅분포' },
  },
};

export const displayFilterList = {
  /**
   * openRTB 페이지 보여질 디스플레이 필터 리스트
   * 배너 (
        카트매칭	    04
        관심상품매칭	    10
        본상품매칭	        17
   헤비유저매칭	    05
        리턴매칭	 	   11
        성향매칭	        19
   베이스광고		        01
   * )
   */
  daily: {
    cw: {
      '01': {
        '04': 1,
        '37': 1,
      },
      '02': {
        '04': 1,
        // '37': 1,
      },
      '03': {
        '04': 1,
        '37': 1,
      },
      '07': {
        '04': 1,
        '37': 1,
      },
    },
  },
  openRTB: {
    '01': {
      '01': 1,
      '04': 1,
      '05': 1,
      '06': 1,
      '08': 1,
      '10': 1,
      '11': 1,
      '13': 1,
      '16': 1,
      '17': 1,
      '18': 1,
      '19': 1,
      '26': 1,
      '28': 1,
      '29': 1,
      '31': 1,
      '34': 1,
      '35': 1,
      '36': 1,
      '37': 1,
      '39': 1,
      '40': 1,
      '41': 1,
      '42': 1,
      '43': 1,
      '44': 1,
      '47': 1,
      '48': 1,
    },
  },
  openRtbTiime: {
    '01': {
      '01': 1,
      '04': 1,
      '05': 1,
      '10': 1,
      '11': 1,
      '16': 1,
      '17': 1,
      '19': 1,
      '37': 1,
      '40': 1,
      '41': 1,
      '42': 1,
      '47': 1,
      '48': 1,
    },
  },
  freq: {
    '01': {
      '10': 1,
      '11': 1,
      '16': 1,
      '17': 1,
      '31': 1,
      '34': 1,
      '04': 1,
      '05': 1,
      '06': 1,
    },
  },
  campaign: {
    ctr: {
      '07': {
        '11': 1,
        '01': 1,
      },
      '08': {
        '46': 1,
        '53': 1,
      },
    },
  },
  dataCanter: {
    audience: {
      '01': {
        '11': 1,
        '19': 1,
        '28': 1,
        '04': 1,
        '01': 1,
      },
      '03': {
        '28': 1,
      },
    },
  },
  localTargetingStatistics: {
    '01': {
      '01': 1,
      '19': 1,
    },
    '02': {
      '01': 1,
    },
    '03': {
      '01': 1,
      '19': 1,
    },
    '06': {
      '01': 1,
    },
    '07': {
      '01': 1,
      '19': 1,
    },
  },
  timeExhaustion: {
    '01': {
      '10': 1,
      '11': 1,
      '13': 1,
      '16': 1,
      '17': 1,
      '18': 1,
      '19': 1,
      '26': 1,
      '28': 1,
      '29': 1,
      '31': 1,
      '34': 1,
      '35': 1,
      '36': 1,
      '37': 1,
      '39': 1,
      '40': 1,
      '41': 1,
      '42': 1,
      '04': 1,
      '05': 1,
      '06': 1,
      '08': 1,
      '01': 1,
    },
    '02': {
      '10': 1,
      '11': 1,
      '16': 1,
      '17': 1,
      '18': 1,
      '19': 1,
      '06': 1,
      '04': 1,
      '05': 1,
      '01': 1,
    },
    '03': {
      '10': 1,
      '11': 1,
      '16': 1,
      '17': 1,
      '18': 1,
      '19': 1,
      '26': 1,
      '28': 1,
      '37': 1,
      '06': 1,
      '04': 1,
      '05': 1,
      '01': 1,
    },
    '05': {
      '20': 1,
      '22': 1,
      '23': 1,
      '30': 1,
      '32': 1,
    },
    '06': {
      '10': 1,
      '11': 1,
      '17': 1,
      '18': 1,
      '19': 1,
      '06': 1,
      '04': 1,
      '05': 1,
      '01': 1,
    },
    '07': {
      '10': 1,
      '11': 1,
      '16': 1,
      '17': 1,
      '19': 1,
      '24': 1,
      '26': 1,
      '27': 1,
      '28': 1,
      '36': 1,
      '37': 1,
      '40': 1,
      '41': 1,
      '04': 1,
      '05': 1,
      '06': 1,
      '01': 1,
    },
  },
};

export const shoppingCustomized = {
  MOB_SESSION_ROAS: {
    makeHead: (headsMap) => {
      return (
        <ShoppingCell
          type="head"
          headsMap={headsMap}
          itemKey="MOB_SESSION_ROAS"
        />
      );
    },
    makeBody: (rowObj, headsMap) => {
      return (
        <ShoppingCell
          rowObj={rowObj}
          headsMap={headsMap}
          itemKey="MOB_SESSION_ROAS"
        />
      );
    },
    orderFlag: false,
  },
  TRGT_MOB_SESSION_ROAS: { merged: true },
  MOB_SESSION_ORDER_AMT: { merged: true },
  SESSION_ROAS: {
    makeHead: (headsMap) => {
      return (
        <ShoppingCell type="head" headsMap={headsMap} itemKey="SESSION_ROAS" />
      );
    },
    makeBody: (rowObj, headsMap) => {
      return (
        <ShoppingCell
          rowObj={rowObj}
          headsMap={headsMap}
          itemKey="SESSION_ROAS"
        />
      );
    },
    orderFlag: false,
  },
  TRGT_SESSION_ROAS: { merged: true },
  SESSION_ORDER_AMT: { merged: true },
  DIRECT_ROAS: {
    makeHead: (headsMap) => {
      return (
        <ShoppingCell type="head" headsMap={headsMap} itemKey="DIRECT_ROAS" />
      );
    },
    makeBody: (rowObj, headsMap) => {
      return (
        <ShoppingCell
          rowObj={rowObj}
          headsMap={headsMap}
          itemKey="DIRECT_ROAS"
        />
      );
    },
    orderFlag: false,
  },
  TRGT_DIRECT_ROAS: { merged: true },
  DIRECT_ORDER_AMT: { merged: true },
  ROAS: {
    makeHead: (headsMap) => {
      return <ShoppingCell type="head" headsMap={headsMap} itemKey="ROAS" />;
    },
    makeBody: (rowObj, headsMap) => {
      return (
        <ShoppingCell rowObj={rowObj} headsMap={headsMap} itemKey="ROAS" />
      );
    },
    orderFlag: false,
  },
  TRGT_ROAS: { merged: true },
  ORDER_AMT: { merged: true },
  ECPM: {
    makeHead: (headsMap) => {
      return <ShoppingCell type="head" headsMap={headsMap} itemKey="ECPM" />;
    },
    makeBody: (rowObj, headsMap) => {
      return (
        <ShoppingCell rowObj={rowObj} headsMap={headsMap} itemKey="ECPM" />
      );
    },
    orderFlag: false,
  },
  TRGT_ECPM: { merged: true },
};

export const rtbPlatformList = [
  { label: i18next.t('전체'), value: 'all' },
  { label: i18next.t('웹'), value: '01' },
  { label: i18next.t('모바일'), value: '02' },
  { label: i18next.t('모바일웹'), value: '10' },
  { label: i18next.t('APP'), value: '11' },
  { label: i18next.t('모바일_NA'), value: '08' },
  { label: i18next.t('모바일_NA_일반'), value: '04' },
  { label: i18next.t('모바일_NA_M.TOP'), value: '03' },
  { label: i18next.t('모바일_NA_APP'), value: '09' },
  { label: i18next.t('비즈보드'), value: '05' },
  { label: i18next.t('비즈보드_일반'), value: '06' },
  { label: i18next.t('비즈보드_APP'), value: '07' },
];
